// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// NgRx actions / selectors
import { setFundChartSortColumn } from './sort-column.actions';
import { updateFundChartSecurityOrdering } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/securities/securities.actions';
export const sortColumn = createReducer('', on(setFundChartSortColumn, (state, action) => {
    return action.sortColumn;
}), on(updateFundChartSecurityOrdering, () => {
    return '';
}));
